import { InjectionToken } from '@angular/core';

/**
 * Provides the id of the currently authenticated user to the ag-grid settings.
 *
 * Defined here (instead of importing auth state directly) so this lib stays
 * decoupled from `@wilson/auth/core`. Each app wires this token to its own
 * source of truth (e.g. NGXS `AuthState.userId`).
 *
 * This is necessary because this library cannot depend on @wilson/auth/core directly,
 * because it will cause a circular dependency
 */
export interface AgGridCurrentUserContext {
  getCurrentUserId(): string | null;
}

export const AG_GRID_CURRENT_USER_CONTEXT =
  new InjectionToken<AgGridCurrentUserContext>('AG_GRID_CURRENT_USER_CONTEXT');
